import React, { Component } from 'react';
// import App from '../../App'
import { Container, Row, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Route, Routes, Link, Navigate } from "react-router-dom";
import CasesComponent from '../../Analyst/Cases/List/index';
import CaseSectionsComponent from '../../Analyst/Cases/View/index';
import CreateCasesComponent from '../../Analyst/Cases/Create/index';
import CreateBulkCase from '../Cases/Bulk-Case/index';
import NewsModerationComponent from '../../Analyst/News-Moderation/index';
import '../../Admin/admin-main/main.scss';
import StringConst from '../../Admin/StringConst';
import CompanyMap from '../../Analyst/Cases/RatingCompanyMap'
import InternationalDashboard from '../../Admin/International/index'
import ApiCasesComponent from '../../Analyst/Cases/Api/index';
import withRouter from '../../withRouter';

const CasesComponentwithRouter = withRouter(CasesComponent);
const InternationalDashboardwithRouter = withRouter(InternationalDashboard);
const CreateCasesComponentwithRouter = withRouter(CreateCasesComponent);
const CreateBulkCasewithRouter = withRouter(CreateBulkCase);
const ApiCasesComponentwithRouter = withRouter(ApiCasesComponent);
const CaseSectionsComponentwithRouter = withRouter(CaseSectionsComponent);
const NewsModerationComponentwithRouter = withRouter(NewsModerationComponent);
const CompanyMapwithRouter = withRouter(CompanyMap);

class AnalystMain extends Component {
    render() {
        let pageTitle = StringConst.getPageTitle(this.props.location.pathname)
        return (
            <main className="app-main admin-main">
                <Container fluid className="px-0">
                    <Breadcrumb className="mb-3">
                        <BreadcrumbItem><Link to="/"> Home </Link></BreadcrumbItem>
                        <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        {/*<Correspondent/>*/}
                        <Routes>
                            {/* <Route path="/login" component={App} /> */}
                            <Route exact path="" element={<Navigate to="/case" />} />
                            <Route exact path="/" element={<Navigate to="/case" />} />
                            <Route exact path="/case" element={<CasesComponentwithRouter {...this.props}/> } component={CasesComponent} />
                            <Route exact path="/international" element={<InternationalDashboardwithRouter {...this.props}/>} component={InternationalDashboard} />
                            <Route exact path="/case/create" element={<CreateCasesComponentwithRouter {...this.props}/>} component={CreateCasesComponent} />
                            <Route exact path="/case/create/bulk" element={<CreateBulkCasewithRouter {...this.props}/>} component={CreateBulkCase} />
                            <Route exact path="/case/api" element={<ApiCasesComponentwithRouter {...this.props}/>} component={ApiCasesComponent} />
                            <Route path='/case/View/:caseNo' element={<CaseSectionsComponentwithRouter {...this.props}/>} component={CaseSectionsComponent} />
                            <Route path='/analysts/news-moderation' element={<NewsModerationComponentwithRouter {...this.props}/>} component={NewsModerationComponent} />
                            <Route exact path={this.props.match.path} element={<CasesComponentwithRouter {...this.props}/>} component={CasesComponent} />
                            <Route path='/case/companysearch/:caseNo' element={<CompanyMapwithRouter {...this.props}/>} component={CompanyMap} />
                        </Routes>
                    </Row>
                </Container>
            </main>
        );
    }
}

export default withRouter(AnalystMain);
